import { CandidateJobMatchProfileModule } from "./candidateJobMatchProfile/candidate-job-match-profile.module";
import { CancelJobMatchMeetingModule } from "./cancelJobMatchMeeting/cancel-job-match-meeting.module";
import { JobMatchMeetingsModule } from "./jobMatchMeetings/job-match-meetings.module";
import { ScheduleJobMatchItemModule } from "./scheduleJobMatchItem/schedule-job-match-item.module";
import { SchedulesOnProfileModule } from "./schedulesOnProfile/schedules-on-profile.module";
import { FeedbackExecutionModule } from "./feedbackExecution/feedback-execution.module";
import { SendAssessmentModule } from "./sendAssessment/send-assessment.module";
export const JobMatchActionsModule = angular
    .module('jobMatchActions', [
    CandidateJobMatchProfileModule,
    FeedbackExecutionModule,
    SendAssessmentModule,
    JobMatchMeetingsModule,
    ScheduleJobMatchItemModule,
    SchedulesOnProfileModule,
    CancelJobMatchMeetingModule
])
    .name;
//# sourceMappingURL=job-match-actions.module.js.map